import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useIsAdmin } from '../../shared/hooks/useIsAdmin'

interface AdminGuardProps {
    children: React.ReactNode
}

const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
    const isAdmin = useIsAdmin()
    const history = useHistory()

    useEffect(() => {
        if (!isAdmin) {
            history.replace('/')
        }
    }, [isAdmin, history])

    if (!isAdmin) {
        return null
    }

    return <>{children}</>
}

export default AdminGuard
